import api from "api/axiosConfig";

const { apiBase, public_api } = api;

export async function loadAnalyticsOverview(days = 30) {
  const res = await apiBase.get("/api/analytics/overview", {
    params: { days },
  });
  return res.data;
}

export async function loadAnalyticsEvents(limit = 25) {
  const res = await apiBase.get("/api/analytics/events", {
    params: { limit },
  });
  return res.data;
}

export async function trackAnalyticsEvent({
  eventType,
  spaceId,
  spaceSlug,
  source = "app",
  metadata = {},
}) {
  if (!eventType) return { success: false, tracked: false };

  try {
    const res = await public_api.post("/api/analytics/track", {
      eventType,
      spaceId,
      spaceSlug,
      source,
      pageUrl: typeof window !== "undefined" ? window.location.href : "",
      referrer: typeof document !== "undefined" ? document.referrer : "",
      metadata,
    });

    return res.data;
  } catch (err) {
    // Analytics must never break user-facing pages.
    if (process.env.NODE_ENV === "development") {
      console.warn("Analytics tracking failed:", err.response?.data || err.message);
    }
    return { success: false, tracked: false };
  }
}
